var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "card mt-3", attrs: { "header-bg-variant": "white" } },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row mb-2" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "span",
                { attrs: { "data-test-hook": "plan-cost-header-text" } },
                [_vm._v(" " + _vm._s(_vm.$t("xPlanStatus")) + " ")]
              )
            ])
          ]),
          _c("div", { staticClass: "row mb-1" }, [
            _c("div", { staticClass: "col" }, [
              _c("strong", { attrs: { "data-test-hook": "plan-cost" } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("xCurrentlyNotSubscribedToPlanPleaseAddProduct")
                    ) +
                    " "
                )
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }